export class SessionExpiredError extends Error {
  public override readonly name = 'SessionExpiredError';

  constructor(
    message = 'La sessione Firebase non è più disponibile.',
    public override readonly cause?: unknown,
  ) {
    super(message);
  }
}
